module.exports = __webpack_public_path__ + "b1ba637bcb9ef96160850a736fb78cf3.png";